export enum CustomFieldValidatorType {
  Required = 1,
  Minimum = 2,
  Maximum = 3,
  MaxLength = 4,
}
